// extracted by mini-css-extract-plugin
export default {"main":"SpreadsheetLine_main__O+Z5R"};